<template>
  <tr>
  	<td>
      <router-link :to="`/proforma-invoice/${item.code}/view`" :key="item.code" title="View Proforma Invoice">
        {{ item.code }}
      </router-link>
    </td>
    <td>{{ formatMysqlDate(item.added_time, 'Do MMM, YYYY') }}</td>
    <td>{{ item.type == config.invoiceTypes.customer ? 'Customer' : 'Franchisee' }}</td>
    <td>{{ item.type == config.invoiceTypes.customer ? item.customer_name : item.franchisee_name }}</td>
    <td>{{ item.retailer_name }}</td>
    <!-- <td class="text-xs-right">{{ item.total | roundValue }}</td> -->
    <!-- <td class="text-xs-right">{{ item.discount }}</td> -->
    <!-- <td class="text-xs-right">{{ item.tax | roundValue }}</td> -->
    <td class="text-xs-right">{{ item.grandtotal | roundValue }}</td>
    <td class="text-xs-center">{{ status }}</td>
    <td class="align-center justify-center layout px-0">
      <v-icon small class="mr-1" color="green" v-if="hasConfirmAccess" title="Confirm Proforma Invoice" @click="$emit('confirm', item)">done</v-icon>
      <v-icon small class="mr-1" color="red" v-if="hasEditOrCancelAccess" title="Cancel Proforma Invoice" @click="$emit('cancel', item)">clear</v-icon>
      <router-link :to="`/proforma-invoice/${item.code}`" v-if="hasEditOrCancelAccess" title="Edit Proforma Invoice">
        <v-icon small class="mr-1">edit</v-icon>
      </router-link>
      <a :href="`#/proforma-invoice/${item.code}/print`" v-if="!isCancelled" target="_new" title="Print Proforma Invoice" class="hidden-sm-and-down">
        <v-icon small class="mr-1">print</v-icon>
      </a>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'InvoiceListItem' ,
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.invoiceStatus.pending
    },

    isConfirmed () {
      return this.item.status == this.config.invoiceStatus.confirmed
    },

    isApproved () {
      return this.item.status == this.config.invoiceStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.invoiceStatus.cancelled
    },

    isShipped () {
      return this.item.status == this.config.invoiceStatus.shipped
    },

    isDelivered () {
      return this.item.status == this.config.invoiceStatus.delivered
    },

    status () {
      let status = ""
      switch(this.item.status) {
        case this.config.invoiceStatus.pending:
          status = "Pending"
        break
        case this.config.invoiceStatus.confirmed:
          status = "Confirmed"
        break
        case this.config.invoiceStatus.approved:
          status = "Approved"
        break
        case this.config.invoiceStatus.cancelled:
          status = "Cancelled"
        break
        case this.config.invoiceStatus.shipped:
          status = "Shipped"
        break
        case this.config.invoiceStatus.delivered:
          status = "Delivered"
        break
      }
      return status
    },

    hasConfirmAccess () {
      let access = false
      if ((this.hasAdminPrivilage || this.isSalesManager || this.isBillingStaff) && this.hasEditAccess && this.isPending) {
        access = true
      }
      return access
    },

    hasApproveAccess () {
      let access = false
      if ((this.hasAdminPrivilage || this.isSalesManager) && this.hasEditAccess) {
        access = true
      }
      return access
    },

    hasEditOrCancelAccess () {
      let access = false
      if ((this.hasAdminPrivilage || this.isSalesManager || this.isBillingStaff) && this.hasEditAccess && this.isPending) {
        access = true
      }
      return access
    },

  },

  watch: {
    
  }
}
</script>